import {useCallback, useEffect, useRef, useState} from "react"
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import {loadSolrResults} from "../../services/solr.service.js"
import {EventResult} from "./EventResult.jsx"
import {getTranslations} from "../../services/language.service.js";
import {calculatePosition} from "../../services/masonry.service.js";

export const EventSearch = () => {
    const [search, setSearch] = useState('')
    const [filter, setFilter] = useState({})

    const [items, setItems] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const container = useRef(null);
    const LANG = getTranslations()
    const [noResultsText, setNoResultsText] = useState(LANG.noResults);
    const [siteId, setSiteId] = useState("");
    const [reloadToken, setReloadToken] = useState(0);



    const mapResults = {
        lectures: (element) => {
            const lectures = []

            for (const e of element.children) {
                lectures.push(e.textContent)
            }

            return lectures
        },
        url: 'string',
        title: 'string',
        subTitle: 'string',
        teaser: 'string',
        date: 'string',
        category: 'string',
        speciality: 'string',
        eventType: 'string',
        eventClient: 'string',
        place: 'string',
        freeSeats: 'number',
        availabilityText: 'string',
        stickyNews: 'boolean',
        image: 'string',
        eventImplementationType: 'string'
    }

    const loadResponse = useCallback(async ({page = currentPage, append = true, force = false} = {}) => {
        if (!force && !hasMore) {
            setIsLoading(false)
            return
        }

        const solrParams = {
            q: search === '' ? '*' : search.replace('*', ''),
            page
        }

        const filtersWithoutSearch = Object.fromEntries(Object.entries(filter).filter(([key]) => key !== 'search'));

        const filters = {
            ...filtersWithoutSearch,
            type: '40'
        }

        try {
            const response = await loadSolrResults(solrParams, filters, mapResults)
            setItems((prevItems) => append ? [...prevItems, ...response.results] : response.results)
            setCurrentPage(page + 1)
            setHasMore(response.hasMore)
            document.dispatchEvent(new CustomEvent('facets', {
                detail: response.facets
            }))
        } catch (error) {
            if (error?.name !== 'AbortError') {
                console.error('EventSearch loadResponse failed', error)
            }
        } finally {
            setIsLoading(false)
        }
    }, [currentPage, filter, hasMore, search])

    useEffect(() => {

        if (document.querySelector('.solr-event-results') !== null && document.querySelector('.solr-event-results').dataset.siteId) {
            setSiteId(document.querySelector('.solr-event-results').dataset.siteId)
        }

        if (document.querySelector('.solr-event-results') !== null && document.querySelector('.solr-event-results').dataset.siteId === 'werde-aktuar') {
            setNoResultsText(LANG.noResultsDGVFM)
        }

        const handleFilter = (e) => {
            setFilter(e.detail)
        }

        const handleSearch = (e) => {
            setSearch(e.detail)
        }

        const handleReset = () => {
            setSearch('')
            setFilter({})
        }

        const handleRestore = () => {
            setReloadToken((prev) => prev + 1)
        }

        document.addEventListener('filter', handleFilter)
        document.addEventListener('search', handleSearch)
        document.addEventListener('reset', handleReset)
        document.addEventListener('event-search:restore', handleRestore)

        return () => {
            document.removeEventListener('filter', handleFilter)
            document.removeEventListener('search', handleSearch)
            document.removeEventListener('reset', handleReset)
            document.removeEventListener('event-search:restore', handleRestore)
        }
    },[])

    useEffect(() => {
        setIsLoading(true);
        setCurrentPage(1)
        setHasMore(true)
        void loadResponse({page: 1, append: false, force: true})
    }, [search, filter, reloadToken]);

    useEffect(() => {
        setIsLoading(true);
    }, []);

    const loadNextItems = useCallback(async () => {
        if (isLoading) return;

        setIsLoading(true);

        void loadResponse({page: currentPage, append: true})
    }, [currentPage,isLoading,loadResponse]);

    useEffect(() => {
        const handleScroll = () => {
            if (container.current === null) {
                return
            }

            const { clientHeight } =
                document.documentElement;
            const { top,height } =
                container.current.getBoundingClientRect();
            if (top + height - clientHeight < 400) {
                void loadNextItems();

            }
        };
        if (hasMore) {
            window.addEventListener("scroll", handleScroll);
        }
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [loadNextItems]);

    useEffect(() => {
        if (!isLoading && items.length > 4 && siteId !== 'eaa') {
            setItems(() => [...calculatePosition(items)]);
        }
    },[isLoading])


    return (
        <div ref={container}>
            {(items.length < 1 && !isLoading) && <p>{noResultsText}</p>}
            <ResponsiveMasonry
                columnsCountBreakPoints={{768: 1, 992: 2, 1300: 2}}
                className="masonry"
            >
                <Masonry
                    style={{gap: "16px"}}>
                    {items && items.map((result,index) => <EventResult index={index} result={result} siteId={siteId}></EventResult>)}
                </Masonry>
            </ResponsiveMasonry>

            {isLoading && <span className="loader"></span>}

        </div>

    )


}
